import SectionHeading from "@/components/base/SectionHeading";
import Reveal from "@/components/base/Reveal";
import { updateLog } from "@/mocks/siteData";

export default function Updates() {
  return (
    <section id="updates" className="scroll-mt-20 bg-background-50">
      <div className="mx-auto w-full px-4 py-16 md:px-8 md:py-20">
        <Reveal>
          <SectionHeading
            eyebrow="目录整理动态"
            title="最近整理好的条目都在这儿"
            description="新增或补充的目录会集中记录在这里，收藏本页就能随时知道该从哪一条接着看。"
          />
        </Reveal>

        <div className="mt-10 grid gap-4 lg:grid-cols-2">
          {updateLog.map((entry, index) => (
            <Reveal key={entry.id} delay={index * 60}>
              <article className="flex h-full gap-4 rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-300">
                <div className="flex w-16 shrink-0 flex-col items-center justify-center rounded-md bg-background-100 py-3">
                  <span className="font-heading text-sm font-bold text-foreground-900">{entry.date}</span>
                </div>
                <div className="flex-1">
                  <span className="inline-flex rounded-full bg-accent-100 px-2.5 py-1 text-[11px] font-medium text-accent-800">
                    {entry.category}
                  </span>
                  <h3 className="mt-2.5 font-heading text-base font-semibold text-foreground-950">{entry.title}</h3>
                  <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">{entry.detail}</p>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}